export class GraphCount {
    thumbnailCount: number = 0;
    selectedParam: any = ''
}